import React from 'react';
import { useNavigate } from 'react-router-dom';
import { VenereIconBox } from '../../shared/ui';

export interface FolderItem {
  id: string;
  title: string;
  icon: React.ComponentType<{ size?: number; color?: string }>;
  redirect: string;
}

interface VenereFoldersGridProps {
  items: FolderItem[];
}

const VenereFoldersGrid: React.FC<VenereFoldersGridProps> = ({ items }) => {
  const navigate = useNavigate();

  const handleItemClick = (redirect: string) => {
    navigate(redirect);
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-4xl mx-auto">
      {items.map((item) => {
        console.log('Rendering item:', item.id, 'with icon:', item.icon);
        return (
          <div key={item.id} className="flex flex-col items-center gap-4 p-4 text-center" >
            <VenereIconBox 
              icon={item.icon}
              size={48}
              color={"var(--venere-skin)"}
              backgroundColor={"var(--venere-navy)"}
              className="cursor-pointer"
              onClick={() => handleItemClick(item.redirect)}
            />
            <div className="venere-text-primary font-fold leading-[20px]">
              {item.title}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VenereFoldersGrid; 